<app-page-loading></app-page-loading>
<router-outlet></router-outlet>

<app-confirm-modal
  [btnContent]="'shared.confirm' | translate"
  [btnStyle]="'main'"
  (confirm)="onConfirmed()"
  [content]="confirmMsg"
  [id]="'warning-license'"
  [showOkOnlyBtn]="true"
></app-confirm-modal>

<app-model
  [dimensions]="{ width: 700, height: 750 }"
  [id]="'cms-mode-modal'"
  [title]=""
  [hasBackBtn]="false"
  [hasTitle]="false"
  [isNewModel]="true"
  class="app-model"
>
  <div
    *ngIf="selectedTranslationObj !== null"
    modal-header
    class="follow-up-item-model-header w-100"
  >
    <label class="modal-title">
      {{ "shared.edit" | translate }}
      <span *ngIf="selectedValueForTranslation !== undefined">
        ( {{ selectedValueForTranslation }} )
      </span>
      {{ "shared.label" | translate }}
    </label>
  </div>

  <div
    *ngIf="selectedTranslationObj !== null"
    modal-content
    class="add-goal-model-content border-top"
  >
    <app-cms-mode-title-customizer
      #cmsModeTitleCustomizer
      [lang]="lang"
      [selectedTranslationObj]="selectedTranslationObj"
    ></app-cms-mode-title-customizer>
  </div>
</app-model>

<!-- image preview -->
<app-model
  [id]="'image-preview'"
  [hasHeader]="false"
  [mode]="modeEnum.Center"
  [modalSize]="sizeEnum.lg"
  (close)="closePreview()"
>
  <div center-modal-content>
    <app-image-preview-modal
      *ngIf="previewingImage"
      [language]="lang"
      [src]="selectedImageSrc"
      [width]="sizeEnum.lg"
    ></app-image-preview-modal>
  </div>
</app-model>
